var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("发帖记录")]), _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "list"
  }, _vm._l(_vm.list, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "list-item",
      on: {
        click: function click($event) {
          return _vm.toDetail(item);
        }
      }
    }, [_c("img", {
      staticClass: "cover",
      attrs: {
        src: item.cover_url,
        alt: "",
        loading: "lazy"
      }
    }), item.edit_count ? _c("div", {
      staticClass: "edit-num"
    }, [_vm._v(_vm._s(item.edit_count))]) : _vm._e(), _c("div", {
      staticClass: "title"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c("div", {
      staticClass: "line"
    }), _c("div", {
      staticClass: "info"
    }, [_c("div", [_vm._v("流量池：" + _vm._s(_vm.getFlowPoolText(item.flow_pool)))]), _c("div", [_vm._v(" 收藏：" + _vm._s(item.collect_count || 0) + "   浏览：" + _vm._s(item.view_count || 0) + " ")]), _c("div", [_vm._v("最近更新：" + _vm._s(item.updated_at || ""))])])]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };